import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';

import appConfig from '@/config/appConfig.typed';
import {AD_CLEANING_CONTACTS_HEADER_TITLE} from '@/consts/localization/localizationKeys';
import amplitudeADTracking from '@/services/analytics/amplitude/amplitudeADTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import {getLocalizedStrings} from '@/services/localization/localizationService';
import {selectDeviceType} from '@/state/selectors/device';

import AdvancedDiagnosticCarouselPage from '../components/AdvancedDiagnosticCarouselPage';
import AdvancedDiagnosticCleaningContactsButtons from './AdvancedDiagnosticCleaningContactsButtons';
import AdvancedDiagnosticCleaningContactsSlides from './AdvancedDiagnosticCleaningContactsSlides';

const AdvancedDiagnosticCleaningContacts = () => {
    const [isLastSlide, setIsLastSlide] = useState(false);
    const deviceType = useSelector(selectDeviceType);
    const carouselData = appConfig.getAdConfig(deviceType, 'cleaningGuide');

    const localizedStrings = getLocalizedStrings();

    useEffect(() => {
        if (!isLastSlide) return;

        amplitudeADTracking.trackADInitialQuestionnaireScreen();
        googleAnalyticsService.trackAdInitialQuestionnaireScreenView();
    }, [isLastSlide]);

    return (
        <AdvancedDiagnosticCarouselPage
            slides={() =>
                AdvancedDiagnosticCleaningContactsSlides({
                    carouselData,
                    sectionTitle: localizedStrings[AD_CLEANING_CONTACTS_HEADER_TITLE],
                })
            }
            headerTitleKey={AD_CLEANING_CONTACTS_HEADER_TITLE}
            onLastVisibleChange={setIsLastSlide}
        >
            <div className='mt-6 flex flex-col gap-4 px-8 ml:mx-auto ml:mt-8 ml:w-full ml:max-w-[360px] ml:px-0'>
                <AdvancedDiagnosticCleaningContactsButtons isLastSlide={isLastSlide} />
            </div>
        </AdvancedDiagnosticCarouselPage>
    );
};

export default AdvancedDiagnosticCleaningContacts;
